import React, { useMemo, useState } from 'react';
import { SlideDown } from 'react-slidedown';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { AirFareConditions } from 'models/flightValidation';

import {
  Arrow,
  Card,
  Container,
  Content,
  Disclaimer,
  FlightTitle,
  FlightPolicy,
  FlightPolicyValue,
  Header,
  Title,
} from './styles';

interface Props {
  policies: AirFareConditions[];
}

const CancellationPolicies = ({ policies }: Props) => {
  const { t } = useStoreTranslation();

  const [showPolicies, setShowPolicies] = useState(false);

  const toggleShowPolicies = () => setShowPolicies(!showPolicies);
  const title = useMemo(() => `${t('flightDetails.cancellationPolicies.title2')} ${policies[0].flight}`, [policies, t]);

  return (
    <Card>
      <Header onClick={toggleShowPolicies}>
        <Title>{title}</Title>
        <Arrow className={showPolicies ? 'active' : ''} />
      </Header>
      <SlideDown>
        {showPolicies && (
          <Container>
            {policies.map((policy, index) => (
              <Content key={index}>
                <FlightTitle>{`${t('flightDetails.cancellationPolicies.flight')} ${policy.flight}`}</FlightTitle>
                <p>
                  <FlightPolicy>{`${t('flightDetails.cancellationPolicies.change.title')}: `}</FlightPolicy>
                  <FlightPolicyValue>
                    {policy.changesAllowed
                      ? t('flightDetails.cancellationPolicies.change.allowed')
                      : t('flightDetails.cancellationPolicies.change.notAllowed')}
                  </FlightPolicyValue>
                </p>
                <p>
                  <FlightPolicy>{`${t('flightDetails.cancellationPolicies.cancellation.title')}: `}</FlightPolicy>
                  <FlightPolicyValue>
                    {policy.cancellationAllowed
                      ? t('flightDetails.cancellationPolicies.cancellation.allowed')
                      : t('flightDetails.cancellationPolicies.cancellation.notAllowed')}
                  </FlightPolicyValue>
                </p>
                <p>
                  <FlightPolicy>{`${t('flightDetails.cancellationPolicies.noShow.title')}: `}</FlightPolicy>
                  <FlightPolicyValue>
                    <>
                      {`${t('flightDetails.cancellationPolicies.noShow.beginText')} ${
                        policy.changesAllowed
                          ? t('flightDetails.cancellationPolicies.noShow.canChange')
                          : t('flightDetails.cancellationPolicies.noShow.cantChange')
                      }, ${
                        !policy.changesAllowed && policy.noShow
                          ? t('flightDetails.cancellationPolicies.noShow.canRefund')
                          : ''
                      }
                        ${
                          !policy.changesAllowed && !policy.noShow
                            ? t('flightDetails.cancellationPolicies.noShow.cantRefund')
                            : ''
                        }
                        ${
                          policy.changesAllowed && policy.noShow
                            ? t('flightDetails.cancellationPolicies.noShow.orCanRefund')
                            : ''
                        }
                        ${
                          policy.changesAllowed && !policy.noShow
                            ? t('flightDetails.cancellationPolicies.noShow.butCantRefund')
                            : ''
                        }`}
                      {t('flightDetails.cancellationPolicies.noShow.endText')}
                    </>
                  </FlightPolicyValue>
                </p>
              </Content>
            ))}
            <Disclaimer>{t('flightDetails.cancellationPolicies.disclaimer')}</Disclaimer>
          </Container>
        )}
      </SlideDown>
    </Card>
  );
};

export default CancellationPolicies;
